export default (array, value, key) =>
  (array || []).map((item) => item && item[key]).includes(value);
